module.exports = __webpack_public_path__ + "public/Icons/rightArrowWhite.svg?a9bea812";